<template>
  <div class="loadingPage">
    loading page
  </div>
</template>

<script>
export default {
  name: 'loadingPage',
  created() {
    this.$router.push({ path: '/login' });
  },
}
</script>
<style lang="scss">

.loadingPage {
  height: 100%;
  width: 100%;
}
</style>